import { keyValue, series } from '../types.js';
import { legendData, legendKeyData } from './types.js';
export const mapLegendData = (series: series[]): legendData[] => series.map(s => ({
  name: s.name,
  type: s.type,
  color: s.color
}));
export const mapKeyLegendData = (series: series[], key: keyValue): legendKeyData[] => series.map(s => ({
  name: s.name,
  type: s.type,
  color: s.color,
  value: s.data.find(d => d.key?.toString() === key.toString())?.value,
  yTarget: s.yTarget ?? 'left'
})).filter(x => Number.isFinite(x.value));